package com.partejar.app.core.ui.components

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation
import com.partejar.app.core.format.formatBrazilianCents

internal object CurrencyVisualTransformation : VisualTransformation {
    override fun filter(text: AnnotatedString): TransformedText {
        val cents = text.text.toLongOrNull() ?: return TransformedText(text, OffsetMapping.Identity)
        val formatted = formatBrazilianCents(cents)
        val digitsBefore = IntArray(formatted.length + 1) { index -> formatted.take(index).count(Char::isDigit) }
        val padding = formatted.count(Char::isDigit) - text.length
        return TransformedText(AnnotatedString(formatted), object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int {
                if (offset == text.length) return formatted.length
                return digitsBefore.indexOfFirst { it >= offset + padding }.coerceAtLeast(0)
            }
            override fun transformedToOriginal(offset: Int): Int =
                (digitsBefore[offset] - padding).coerceIn(0, text.length)
        })
    }
}
